import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { useAppSelector } from "../../../store/hooks";
import { vehicleHistoryKeys } from "../service/entity";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
export var RecallDetailsCatalogView = function (props) {
    var _crud$vehicleHistoryK;
    var value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'RetroFitmentDetails' : _a;
    var crud = useAppSelector(function (state) { return state.crud; });
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var currValue = value[name];
    var pagingColumns = [{
            field: 'Docname',
            headerName: 'Recall name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.RecallName ? "".concat(row === null || row === void 0 ? void 0 : row.RecallName) : '-'; },
            minWidth: isDesktop ? 200 : 160
        }, {
            field: 'Docdate',
            headerName: 'Document date',
            valueFormatter: function (val, row) {
                if (row !== null && row !== void 0 && row.DocDate) {
                    var DocDate = row !== null && row !== void 0 && row.Docdate ? dayjs.utc(row === null || row === void 0 ? void 0 : row.Docdate).format('DD MMM, YYYY') : '-';
                    return DocDate;
                }
                else {
                    return '-';
                }
            },
            minWidth: isDesktop ? 200 : 160
        }, {
            field: 'PartServiceName',
            headerName: 'Part/Service name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.PartServiceName ? "".concat(row === null || row === void 0 ? void 0 : row.PartServiceName) : '-'; },
            minWidth: isDesktop ? 200 : 160
        }, {
            field: 'JOBCARD',
            headerName: 'Job card no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.JobCardNo ? "".concat(row === null || row === void 0 ? void 0 : row.JobCardNo) : '-'; },
            minWidth: isDesktop ? 200 : 160
        }, {
            field: 'JobCardDate',
            headerName: 'Job card date',
            valueFormatter: function (val, row) {
                var JobCardDate = row !== null && row !== void 0 && row.JobCardDate ? dayjs.utc(row === null || row === void 0 ? void 0 : row.JobCardDate).format('DD MMM, YYYY') : '-';
                return JobCardDate;
            },
            minWidth: isDesktop ? 200 : 160
        }, {
            field: 'Reason',
            headerName: 'Racall reason',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.Reason ? "".concat(row === null || row === void 0 ? void 0 : row.Reason) : '-'; },
            minWidth: isDesktop ? 300 : 160
        }, {
            field: 'ReferenceNo',
            headerName: 'Reference no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ReferenceNo ? "".concat(row === null || row === void 0 ? void 0 : row.ReferenceNo) : '-'; },
            minWidth: isDesktop ? 200 : 160
        }, {
            field: 'SupplierInvoiceNo',
            headerName: 'Supplier invoice no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.SupplierInvoiceNo ? "".concat(row === null || row === void 0 ? void 0 : row.SupplierInvoiceNo) : '-'; },
            minWidth: isDesktop ? 200 : 160
        }, {
            field: 'SupplierInvoiceDate',
            headerName: 'Supplier invoice date',
            valueFormatter: function (val, row) {
                var JobCardDate = row !== null && row !== void 0 && row.SupplierInvoiceDate ? dayjs.utc(row === null || row === void 0 ? void 0 : row.SupplierInvoiceDate).format('DD MMM, YYYY') : '-';
                return JobCardDate;
            },
            minWidth: isDesktop ? 200 : 160
        },
        // {
        //     field: 'RecallType',
        //     headerName: 'Racall Type',
        //     valueFormatter: (val, row) => (row?.RecallType ? `${(row?.RecallType)}` : '-'),
        //     minWidth: isDesktop ? 200 : 160,
        // },
        {
            field: 'ISRecalled',
            headerName: ' Recalled status',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ISRecalled ? "".concat(row === null || row === void 0 ? void 0 : row.ISRecalled) : '-'; },
            minWidth: isDesktop ? 280 : 160
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Recall details",
        isCollapsible: true,
        columns: pagingColumns,
        disableAddRow: true,
        disableDeleteRow: true
        // disableToolbarActions
        ,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true
        },
        rows: ((_crud$vehicleHistoryK = crud[vehicleHistoryKeys.SeviceHistoryKey]) === null || _crud$vehicleHistoryK === void 0 || (_crud$vehicleHistoryK = _crud$vehicleHistoryK.data) === null || _crud$vehicleHistoryK === void 0 ? void 0 : _crud$vehicleHistoryK.RetroFitmentDetails) || [],
        error: error === null || error === void 0 ? void 0 : error[name]
    });
};
